import React from 'react'
import { connect } from 'react-redux'
import { Avatar, MyAvatar, ImageUpload } from 'components/Avatar'
import { T } from 'components/Translations'
import { UPLOAD_PHOTO_MODAL, GALLERY_MODAL } from 'components/Modal/modalTypes'
import { openModal, goToUpgrade } from 'store/actions'
import { POLICY_IDS } from 'common/constants'
import { isGold } from 'utils'

import StyledAvatarList from './StyledAvatarList'

const AvatarList = ({ user, ownProfileId, upgraded, openModal, goToUpgrade }) => {
  if (!user.media) return <Avatar user={user} />

  const noPhoto = user.media[0].uri.includes('nophoto_')
  const openImage = index => openModal(GALLERY_MODAL, { user, index })
  const ownProfile = user.id == ownProfileId

  const onUserPhotoClick = index => {
    upgraded ? openModal(GALLERY_MODAL, { user, index }) : goToUpgrade(POLICY_IDS.GALLERY, user.nickname, user.id)
  }

  const renderOwnGallery = () => (
    <>
      <div className="profile-image" onClick={() => (noPhoto ? openModal(UPLOAD_PHOTO_MODAL) : openImage(0))}>
        <MyAvatar />
      </div>
      <div className="gallery">
        {user.media?.slice(1, 3).map((m, i) => (
          <div className="item" key={i} onClick={() => openImage(i + 1)}>
            {i == 1 && user.media?.length >= 4 && <T as="div" className="show-all" label="actions/viewAll" />}
            <Avatar user={user} mediaIndex={i + 1} />
          </div>
        ))}
        <div className="item">
          <ImageUpload onClick={() => openModal(UPLOAD_PHOTO_MODAL)} />
        </div>
      </div>
    </>
  )

  const renderUserGallery = () => (
    <>
      <div className="profile-image" onClick={() => onUserPhotoClick()}>
        <Avatar user={user} />
        <h3 className="username--mobile">
          {user.screenName}
          <span className={`online-indicator ${user.online ? 'online' : 'offline'}`} />
        </h3>
      </div>
      <div className="gallery">
        {user.media?.slice(1, 4).map((m, i) => (
          <div className="item" key={i} onClick={() => onUserPhotoClick(i + 1)}>
            {i == 2 && user.media?.length >= 5 && <div className="show-all">Show all</div>}
            <Avatar user={user} mediaIndex={i + 1} />
          </div>
        ))}
      </div>
    </>
  )

  return <StyledAvatarList>{ownProfile ? renderOwnGallery() : renderUserGallery()}</StyledAvatarList>
}

export default connect(
  ({ myProfile }) => ({
    ownProfileId: myProfile.id,
    upgraded: isGold(myProfile),
  }),
  { openModal, goToUpgrade }
)(AvatarList)
